import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { transparentize } from '../../helpers';

const BUTTON_DIMENSION = 30;

export const paginationButtonBaseStyle = css`
  border-radius: ${theme.borderRadius.small};
  height: ${BUTTON_DIMENSION}px;
  margin: ${theme.spacing(0.75)};
  position: relative;
  transition: 100ms all ease-in-out;
  width: ${BUTTON_DIMENSION}px;
  &:hover {
    background: ${theme.colors.neutral10};
  }
  &:focus {
    outline: none;
    &:before {
      border-radius: ${theme.borderRadius.medium};
      border: 3px solid ${transparentize(0.4, theme.colors.primary50)};
      content: '';
      height: ${BUTTON_DIMENSION + parseInt(theme.borderRadius.medium)}px;
      left: -4px;
      position: absolute;
      top: -4px;
      width: ${BUTTON_DIMENSION + parseInt(theme.borderRadius.medium)}px;
    }
  }
`;

export const paginationButtonSelectedStyle = css`
  outline: 1px solid ${theme.colors.primary50};
  background: ${theme.colors.neutral10};
  font-weight: ${theme.font.weight.semibold};
`;

export const paginationPageByPageContainerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  padding: ${theme.spacing(1)};
`;

export const paginationPageByPageRowStyle = css`
  display: flex;
`;

export const paginationPageByPageTextStyle = css`
  margin: 0;
  margin-right: ${theme.spacing(1)};
  margin-top: ${theme.spacing(1)};
`;

export const paginationPageByPageTotalTextStyle = css`
  margin: 0;
  margin-left: ${theme.spacing(1)};
  margin-top: ${theme.spacing(1)};
`;

export const paginationContainerBaseStyle = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${theme.spacing(1)};
`;

export const paginationContainerSpaceBetweenStyle = css`
  justify-content: space-between;
`;

export const paginationContainerFlexEndStyle = css`
  justify-content: flex-end;
`;

export const paginationControlsStyle = css`
  align-items: center;
  display: flex;
`;

export const paginationPageLabelStyle = css`
  margin: 0;
  margin-right: ${theme.spacing(1)};
`;

export const paginationGoToPageFieldStyle = css`
  width: 105px;
`;

export const paginationPageSelectorContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const paginationPageSelectorLabelStyle = css`
  margin: 0;
  margin-right: ${theme.spacing(2)};
`;

export const paginationNumFieldStyle = css`
  padding: 0;
  width: 50px;

  input {
    text-align: center;
  }
`;

export const paginationInlineFlexStyle = css`
  display: inline-flex;
`;

export const paginationNextButtonMarginStyle = css`
  margin-left: ${theme.spacing(1.5)};
`;

export const paginationFormStyle = css`
  display: inline;
  margin: ${theme.spacing(0, 1)};
`;

export const paginationErrorTextStyle = css`
  margin-top: ${theme.spacing(0.5)};
`;
